// pages/LoginPage.tsx
import { useEffect, useState } from 'react';
import { api } from '../services/api';
import { useNavigate } from 'react-router-dom';


export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [userInfo, setUserInfo] = useState<any>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 🔹 Vérifie si l'URL contient loginCode & clientCode
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const loginCode = params.get('loginCode');
    const clientCode = params.get('clientCode');
    const userId = params.get('userId');
    const from = params.get('from') ?? "";

    if (loginCode && clientCode && userId && from) {
      // Stocke directement en localStorage
      localStorage.setItem('loginCode', loginCode);
      localStorage.setItem('clientCode', clientCode);
      localStorage.setItem('userId', userId);
      localStorage.setItem('from', from);

      // Redirige instantanément
      navigate('/dashboard');
      return;
    }
  }, [navigate]);

  const handleLogin = async () => {
    try {
      setError('');
      setLoading(true); // 🟢 début du chargement
      const response = await api.get('/me', {
        headers: {
          'X-EMAIL': email,
          'X-PASSWORD': password,
        },
        withCredentials: false, // true seulement si tu utilises des cookies
      });
      setUserInfo(response.data);
      localStorage.setItem('loginCode', response.data.loginCode);
      localStorage.setItem('clientCode', response.data.clientCode);
      localStorage.setItem('userId', response.data.id);

      navigate('/dashboard');
    } catch (err: any) {
      setUserInfo(null);
      setError(err?.response?.data?.error || 'Erreur de connexion');
    } finally {
      setLoading(false); // 🟢 fin du chargement
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-animated">
      <div className="bg-white p-8 rounded-xl shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold text-center mb-6 text-blueLight">Connexion Alizée</h2>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          className="w-full mb-4 p-3 border rounded-lg"
          disabled={loading}
        />
        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={e => setPassword(e.target.value)}
          className="w-full mb-4 p-3 border rounded-lg"
          disabled={loading}
        />

        <button
          onClick={handleLogin}
          disabled={loading}
          className={`w-full font-semibold py-3 rounded-lg transition ${
            loading
              ? 'bg-blue-400 text-white cursor-not-allowed'
              : 'bg-blueLight text-white hover:bg-blue-700'
          }`}
        >
          {loading ? (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
              <div className="bg-white rounded-xl p-6 shadow-xl flex flex-col items-center gap-4">
                {/* Spinner */}
                <div className="w-10 h-10 border-4 border-blueLight border-t-transparent rounded-full animate-spin"></div>

                {/* Texte */}
                <p className="text-blueLight font-semibold text-center">
                  Connexion en cours…<br />
                  Vous allez être redirigé dans quelques secondes
                </p>
              </div>
            </div>
          ) : 'Se connecter'}
        </button>

        {error && (
          <div className="mt-4 text-red-600 text-sm text-center">{error}</div>
        )}

        {/* {userInfo && (
          <div className="mt-6 bg-green-100 p-4 rounded text-sm">
            <p><strong>Email :</strong> {userInfo.email}</p>
            <p><strong>ClientCode :</strong> {userInfo.clientCode}</p>
            <p><strong>ID :</strong> {userInfo.id}</p>
            <p><strong>LoginCode :</strong> {userInfo.loginCode || 'N/A'}</p>
          </div>
        )} */}
      </div>
    </div>
  );
}
